import { IUnitQuery } from "../../models/unit/query";
import { IUnit, IUnitDetails } from "../../models/unit/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, UnitLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: UnitLoading | UnitLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IUnit> } }
  | { type: "SET_DETAILSS"; payload: { details?: IUnitDetails } }
  | QueryAction<IUnitQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILSS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
